import { useEffect, useState } from 'react';

import { RANKED_ROLES_LIST } from 'bundles/onboarding-common/data/rankedRolesList';
import useGetRolesByIds from 'bundles/onboarding-common/hooks/useGetRolesByIds';
import type { RoleFragment } from 'bundles/onboarding-common/queries/__generated__/RoleFragment';

const useArtificiallyPaginatedRoles = ({ skip = 0, limit = 9 }: { skip?: number; limit?: number }) => {
  const { getRolesByIds } = useGetRolesByIds();
  const [roles, setRoles] = useState<Array<RoleFragment>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getRoles = async () => {
      const selectedRoleIds = RANKED_ROLES_LIST.slice(skip, skip + limit);

      setLoading(true);
      const { data } = await getRolesByIds({ variables: { ids: selectedRoleIds } });

      setRoles(data?.PathwaySkillCareerRoles?.queryRolesByIds ?? []);
      setLoading(false);
    };

    getRoles();
  }, [skip, limit, getRolesByIds]);

  return {
    roles,
    loading,
  };
};

export default useArtificiallyPaginatedRoles;
